import logo from '../../assets/images/logo.png';
import styles from './QRcode.module.css';

export const QRcode = ({ sizeQR, qrCode, paddingQR }) => {
  return (
    <>
      {qrCode && (
        <div
          className={styles.qrCodeBlock}
          style={{
            height: `${sizeQR}rem`,
            width: `${sizeQR}rem`,
            minWidth: `${sizeQR}rem`,
          }}>
          <img
            src={qrCode}
            alt="qr code"
            className={styles.qrBlockImg}
            style={{ border: `${paddingQR}rem solid #fff` }}
          />
          <div className={styles.logoBlock}>
            <img src={logo} alt="logo" />
          </div>
        </div>
      )}
    </>
  );
};
